import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { WithheldIncomeTax } from '../../../models/withheld-income-tax';

import { NotyService } from '../../../services/common/noty.service';
import { WithheldIncomeTaxService } from '../../../services/accounting/withheld-income-tax.service';
import { UserService } from '../../../services/users/user.service';

declare var swal: any;

@Component({
  selector: 'app-withheld-income-tax-form',
  templateUrl: './withheld-income-tax-form.component.html',
  styleUrls: ['./withheld-income-tax-form.component.scss'],
})
export class WithheldIncomeTaxFormComponent implements OnInit {
  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  withheldIncomeTax: WithheldIncomeTax = new WithheldIncomeTax();

  constructor(private route: ActivatedRoute, private location: Location, private notyService: NotyService, private router: Router, private withheldIncomeTaxService: WithheldIncomeTaxService, private userService: UserService) {}

  // Component lifecycle events
  ngOnInit() {
    this.userService.navbarComponent.setTaxesMenu();
    if (this.route.snapshot.params['id'])
      this.withheldIncomeTaxService.edit(Number(this.route.snapshot.params['id'])).then((withheldIncomeTax) => {
        this.withheldIncomeTax = withheldIncomeTax;
      });
  }

  // Component methods
  back() {
    this.location.back();
  }

  delete() {
    swal({
      title: 'Delete Withheld Income Tax ?',
      icon: 'warning',
      className: 'swal-btn-center',
      buttons: {
        b1: {
          text: 'Cancel',
          value: 'cancel',
          className: 'btn btn-outline-secondary btn-sm',
        },
        b2: {
          text: 'Confirm',
          value: 'confirm',
          className: 'btn btn-danger btn-sm',
        },
      },
    })
      .then((value: string) => {
        if (value == 'confirm') {
          let noty: any = this.notyService.modalNotify('Deleting <i class="fas fa-spinner fa-fw fa-pulse"></i>', 'warning', false);
          this.withheldIncomeTaxService
            .delete(this.withheldIncomeTax.id)
            .then((response_json) => {
              noty.close();
              if (response_json.success) {
                this.notyService.notify(response_json.text || 'Withheld Income Tax deleted', 'warning');
                this.router.navigateByUrl('/withheld_income_taxes');
              } else this.notyService.notify(response_json.text || 'Error deleting Withheld Income Tax', 'error');
            })
            .catch(() => {
              noty.close();
              this.notyService.notify('Error deleting Withheld Income Tax', 'error');
            });
        }
      })
      .catch((err: any) => {});
  }

  save(formValid: boolean) {
    this.formSubmitted = true;
    if (!formValid) return;
    this.formSubmitting = true;
    this.withheldIncomeTaxService
      .save(this.withheldIncomeTax)
      .then((response_json) => {
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Withheld Income Tax saved successfully', 'success');
          this.router.navigateByUrl('/withheld_income_taxes');
        } else this.notyService.notify(response_json.text || 'Error saving withheld income tax', 'error');
      })
      .catch(() => {
        this.formSubmitting = false;
        this.notyService.notify('Error saving withheld income tax', 'error');
      });
  }
}
